import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Company from './pages/Company';
import History from './pages/History';
import Certifications from './pages/Certifications.jsx';
import SmokeWindow from './pages/SmokeWindow.jsx';
import VentWindow from './pages/VentWindow.jsx';
import CloserWindow from './pages/CloserWindow.jsx';
import Performance from './pages/Performance.jsx';
import Notice from './pages/Notice.jsx';
import Qna from './pages/Qna.jsx';
import Downloads from './pages/Downloads.jsx';
//import About from "./components/About";
//mport Products from "./components/Products";
//import Solutions from "./components/Solutions";
//import References from "./components/References";
//import News from "./components/News";
//import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path='/' element={<Hero />} />
        <Route path="/company" element={<Company />} />
        <Route path="/history" element={<History />} />
        <Route path="/certifications" element={<Certifications />} />
        <Route path="/products/smoke" element={<SmokeWindow />} />
        <Route path="/products/vent" element={<VentWindow />} />
        <Route path="/products/closer" element={<CloserWindow />} />
        <Route path="/performance" element={<Performance />} />
        <Route path="/notice" element={<Notice />} />
        <Route path="/qna" element={<Qna />} />
        <Route path="/downloads" element={<Downloads />} />
        {/*
        <Route path='/about' element={<About />} />
        <Route path='/products' element={<Products />} />
        <Route path='/solutions' element={<Solutions />} />
        <Route path='/references' element={<References />} />
        <Route path='/news' element={<News />} />
        <Route path='/contact' element={<Contact />} />
        */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;